"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPapp = void 0;
var makeMockTerm_1 = require("./makeMockTerm.js");
var mockUtilityForType_1 = require("./mockUtilityForType.js");
function mockPapp(a, b) {
    var outT = a.type[2];
    if (outT === undefined) {
        console.log(a.type);
    }
    return (0, mockUtilityForType_1.mockUtilityForType)(outT)((0, makeMockTerm_1.makeMockTerm)(outT));
}
exports.mockPapp = mockPapp;
